export enum JobEntity {
  PRODUCT = 'PRODUCT',
  INVOICE = 'INVOICE',
  CUSTOMER = 'CUSTOMER',
  FILING = 'FILING',
  CORPORATION = 'CORPORATION',
  EXPOSURE_SYNC = 'EXPOSURE_SYNC',
}

export enum JobOperation {
  IMPORT = 'IMPORT',
  DELETE = 'DELETE',
  EXPORT = 'EXPORT',
  EXPORT_FILING_REPORT_FOR_CORPORATION = 'EXPORT_FILING_REPORT_FOR_CORPORATION',
  EXPORT_JURISDICTION_TAX_REPORT = 'EXPORT_JURISDICTION_TAX_REPORT',
}

export enum JobStatus {
  PENDING = 'PENDING',
  QUEUED = 'QUEUED',
  PROCESSING = 'PROCESSING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}

export interface SalesTaxJob {
  id: string;
  org_id: string;
  entity: JobEntity;
  entity_id: string;
  operation: JobOperation;
  status: JobStatus;
  file_name?: string;
  file_url?: string;
  total_rows?: number;
  processed_rows?: number;
  success_count?: number;
  failure_count?: number;
  started_at?: number;
  completed_at?: number;
  error_report_file_id?: string;
  export_file_id?: string;
  success_report_url?: string;
  submitted_at: number;
  failure_reasons: string[];
  metadata?: {
    user_id?: string;
  };
}

export interface Job extends SalesTaxJob {
  user?: {
    id: string;
    email: string;
    name: string;
  };
}

export interface JobError {
  id: string;
  job_id: string;
  row_number: number;
  error_message: string;
  raw_row: string;
  created_at: number;
}

export interface ListJobs {
  jobs: Job[];
  total_jobs: number;
  cursor?: string;
}

export interface ListJobErrors {
  job_errors: JobError[];
  total_job_errors: number;
  cursor?: string;
}

export type GetJobResponse = {
  data: Job;
  message: string;
};

export type ListJobsResponse = {
  data: ListJobs;
  message: string;
};

export type ListJobErrorsResponse = {
  data: ListJobErrors;
  message: string;
};

export type ListJobParams = {
  corporation_id: number;
  limit?: number;
  cursor?: string;
  operation?: JobOperation;
  entity?: JobEntity;
  entity_id?: string;
  status?: JobStatus;
};

export type GenerateErrorReportResponse = {
  error_report_file_id: string;
};
